import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  Paper,
  Avatar,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  LinearProgress,
  Button,
  Divider,
  CircularProgress,
  Alert,
  Snackbar
} from '@mui/material';
import {
  Assignment as TaskIcon,
  BugReport as BugIcon,
  Star as StoryIcon,
  Build as TaskTypeIcon,
  CheckCircle as CompletedIcon,
  Cancel as IncompleteIcon,
  Download as DownloadIcon,
//   Epic as EpicIcon
} from '@mui/icons-material';
import TaskDetailsPanel from './taskdetailpanel';
import { useParams } from 'react-router-dom';
import { compareAsc } from 'date-fns';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const CompletedSprintBoard = () => {
  const [completedSprints, setCompletedSprints] = useState([]);
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [sprintDetails, setSprintDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', type: 'success' });
const [selectedIssue, setSelectedIssue] = useState(null);
const [showTaskPanel, setShowTaskPanel] = useState(false);
const [panelOpen, setPanelOpen] = useState(false);
const {projectId} =useParams();
  // Fetch completed sprints on component mount
  useEffect(() => {
    fetchCompletedSprints();
  }, []);

  // Fetch sprint details when selected sprint changes
  useEffect(() => {
    if (selectedSprint) {
      fetchSprintDetails(selectedSprint.id);
    }
  }, [selectedSprint]);

  const fetchCompletedSprints = async () => {
    try {
          const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      setLoading(true);
      const response = await fetch(`${API_URL}/api/active/completed/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
           
          }
        }
      );
      const data = await response.json();
      
      if (data.success) {
        setCompletedSprints(data.data);
        if (data.data.length > 0) {
          setSelectedSprint(data.data[0]);
        }
      } else {
        setError(data.message || 'Failed to fetch completed sprints');
      }
    } catch (err) {
      setError('Network error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchSprintDetails = async (sprintId) => {
    try {
          const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      setDetailsLoading(true);
      const response = await fetch(`${API_URL}/api/active/${sprintId}/details`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
        
          }
        }
      );
      const data = await response.json();
      if (data.success) {
        setSprintDetails(data.data);
      } else {
        setError(data.message || 'Failed to fetch sprint details');
      }
    } catch (err) {
      setError('Network error: ' + err.message);
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleSprintChange = (event) => {
    const sprintId = event.target.value;
    const sprint = completedSprints.find(s => s.id === sprintId);
    setSelectedSprint(sprint);
    setSprintDetails(null); // Clear previous details
  };

  const getIssueTypeIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'bug':
        return <BugIcon fontSize="small" color="error" />;
      case 'story':
        return <StoryIcon fontSize="small" color="success" />;
      case 'epic':
        return <StoryIcon fontSize="small" color="warning" />;
      case 'task':
      default:
        return <TaskTypeIcon fontSize="small" color="primary" />;
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority?.toLowerCase()) {
      case 'high':
        return 'error';
      case 'medium':
        return 'warning';
      case 'low':
        return 'success';
      default:
        return 'default';
    }
  };

  const getSeverityColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case 'critical':
        return 'error';
      case 'major':
        return 'warning';
      case 'minor':
        return 'info';
      case 'trivial':
        return 'success';
      default:
        return 'default';
    }
  };

  const getProgressColor = (value) => {
  if (value < 25) return '#dc3545';      // Red
  if (value < 50) return '#ff9800';      // Orange
  if (value < 75) return '#ffc107';      // Yellow
  return '#28a745';                      // Green
};
// const handleCardClick = (issue) => {
//   setSelectedIssue(issue);
//   setShowTaskPanel(true);
//   setPanelOpen(true); // Add this line
// };


const handleCardClick = async (issue) => {
  try {
    setDetailsLoading(true);
    
    const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }

    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
    
    // Fetch individual issue details instead of using sprint details
    const response = await fetch(`${API_URL}/api/issues/${issue.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        
        }
      }
    );
    const data = await response.json();
    
    
    if (data.success) {
      setSelectedIssue(data.data);
      setShowTaskPanel(true);
      setPanelOpen(true);
    } else {
      // Fallback to sprint details if individual fetch fails
      setSelectedIssue(issue);
      setShowTaskPanel(true);
      setPanelOpen(true);
    }
  } catch (err) {
    //console.error("Error fetching individual issue:", err);
    // Fallback to sprint details
    setSelectedIssue(issue);
    setShowTaskPanel(true);
    setPanelOpen(true);
  } finally {
    setDetailsLoading(false);
  }
};
const handleCloseTaskPanel = () => {
  setShowTaskPanel(false);
  setSelectedIssue(null);
  setPanelOpen(false); // Add this line
};

const handleUpdateIssue = (updatedIssue) => {
  // Optionally refresh sprint details or update local state
};

  const renderIssueCard = (issue, isCompleted) => {
    return (
      <Card 
        key={issue.id}
        sx={{ 
          mb: 2,
          border: isCompleted ? '2px solid #28a745' : '2px solid #dc3545',
          opacity: isCompleted ? 1 : 0.8,
        cursor: 'pointer', // Add this
        '&:hover': { // Add this
          boxShadow: 2,
          transform: 'translateY(-1px)',
          transition: 'all 0.2s ease-in-out'
        }
      }}
      onClick={() => handleCardClick(issue)} 
      >
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {/* {getIssueTypeIcon(issue.type)} */}
              <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
                {issue.key}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              {isCompleted ? (
                <CompletedIcon color="success" fontSize="small" />
              ) : (
                <IncompleteIcon color="error" fontSize="small" />
              )}
              <Tooltip title="Priority" placement='top'>
              <Chip 
                label={issue.priority}
                color={getPriorityColor(issue.priority)}
                size="small"
                sx={{ fontSize: '0.7rem', height: '20px' }}
              /></Tooltip>
              {issue.severity && (
                <Tooltip title="Severity" placement='top'>
                <Chip 
                  label={issue.severity}
                  color={getSeverityColor(issue.severity)}
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: '0.7rem', height: '20px' }}
                /></Tooltip>
              )}
            </Box>
          </Box>
          
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: 500, 
              mb: 1.5, 
              lineHeight: 1.3,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {issue.title}
          </Typography>

          {issue.description && (
            <Typography 
              variant="caption" 
              color="text.secondary" 
              sx={{ 
                mb: 1.5,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                lineHeight: 1.2
              }}
            >
              {issue.description}
            </Typography>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {issue.assignee && issue.assignee !== 'Unassigned' && (
                <Tooltip title={issue.assignee}>
                  <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem', mr: 1 }}>
                    {issue.assignee.charAt(0).toUpperCase()}
                  </Avatar>
                </Tooltip>
              )}
              {/* {issue.storyPoints > 0 && (
                <Chip 
                  label={`${issue.storyPoints} SP`}
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: '0.7rem', height: '20px' }}
                />
              )} */}
            </Box>
            
            {/* {issue.labels && issue.labels.length > 0 && (
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                {issue.labels.slice(0, 2).map((label, index) => (
                  <Chip 
                    key={index}
                    label={label}
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: '0.6rem', height: '18px' }}
                  />
                ))}
                {issue.labels.length > 2 && (
                  <Typography variant="caption" color="text.secondary">
                    +{issue.labels.length - 2}
                  </Typography>
                )}
              </Box> 
            )}*/}
          </Box>
        </CardContent>
      </Card>
    );
  };

  const calculateStats = () => {
    if (!sprintDetails) {
      return {
        totalCompleted: 0,
        totalIncomplete: 0,
        totalIssues: 0,
        completionRate: 0,
        completedStoryPoints: 0,
        totalStoryPoints: 0,
        completedBugs: 0,
        completedStories: 0,
        completedTasks: 0
      };
    }

    const totalCompleted = sprintDetails.completedIssues.length;
    const totalIncomplete = sprintDetails.incompleteIssues.length;
    const totalIssues = totalCompleted + totalIncomplete;
    const completionRate = totalIssues > 0 ? (totalCompleted / totalIssues) * 100 : 0;
    
    const completedStoryPoints = sprintDetails.completedIssues.reduce((sum, issue) => sum + (issue.storyPoints || 0), 0);
    const incompleteStoryPoints = sprintDetails.incompleteIssues.reduce((sum, issue) => sum + (issue.storyPoints || 0), 0);
    const totalStoryPoints = completedStoryPoints + incompleteStoryPoints;
    
    const completedBugs = sprintDetails.completedIssues.filter(issue => issue.type.toLowerCase() === 'bug').length;
    const completedStories = sprintDetails.completedIssues.filter(issue => issue.type.toLowerCase() === 'story').length;
    const completedTasks = sprintDetails.completedIssues.filter(issue => issue.type.toLowerCase() === 'task').length;

    return {
      totalCompleted,
      totalIncomplete,
      totalIssues,
      completionRate,
      completedStoryPoints,
      totalStoryPoints,
      completedBugs,
      completedStories,
      completedTasks
    };
  };

  const handleExport = async (format = 'json') => {
    if (!selectedSprint) return;
    
    try {
          const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
      setExportLoading(true);
      const response = await fetch(`${API_URL}/api/active/${selectedSprint.id}/export?format=${format}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
         
          }
        }
      );
      
      if (response.ok) {
        const contentType = response.headers.get('content-type');
        const filename = response.headers.get('content-disposition')?.split('filename=')[1]?.replace(/"/g, '') || 
                        `${selectedSprint.name}_export.${format}`;
        
        if (format === 'csv' || contentType?.includes('text/csv')) {
          const csvData = await response.text();
          downloadFile(csvData, filename, 'text/csv');
        } else {
          const jsonData = await response.json();
          downloadFile(JSON.stringify(jsonData, null, 2), filename, 'application/json');
        }
        
        setNotification({
          open: true,
          message: `Sprint data exported successfully as ${format.toUpperCase()}`,
          type: 'success'
        });
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Export failed');
      }
    } catch (err) {
      setNotification({
        open: true,
        message: 'Export failed: ' + err.message,
        type: 'error'
      });
    } finally {
      setExportLoading(false);
    }
  };

  const downloadFile = (data, filename, type) => {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const stats = calculateStats();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button variant="contained" onClick={fetchCompletedSprints}>
          Retry
        </Button>
      </Box>
    );
  }

  if (completedSprints.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          No completed sprints found
        </Typography>
      </Box>
    );
  }

  return (
  <Box sx={{ width: '100%', p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Box>
          <Typography variant="h4"  sx={{ fontWeight: "bold" }}>
            Completed Sprints
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
            Review completed and incomplete issues from past sprints
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Select Sprint</InputLabel>
            <Select
              value={selectedSprint?.id || ''}
              label="Select Sprint"
              onChange={handleSprintChange}
            >
              {completedSprints.map((sprint) => (
                <MenuItem key={sprint.id} value={sprint.id}>
                  {sprint.name} ({new Date(sprint.startDate).toLocaleDateString()} to {new Date(sprint.endDate).toLocaleDateString()})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          {/* <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={() => handleExport('json')}
            disabled={!selectedSprint || exportLoading}
            sx={{ height: '56px', mr: 1 }}
          >
            {exportLoading ? <CircularProgress size={20} /> : 'JSON'}
          </Button>
          
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={() => handleExport('csv')}
            disabled={!selectedSprint || exportLoading}
            sx={{ height: '56px' }}
          >
            CSV
          </Button> */}
        </Box>
      </Box>

      {selectedSprint && (
        <>
          {/* Sprint Summary */}
          <Paper sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Sprint Summary - {selectedSprint.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {new Date(selectedSprint.startDate).toLocaleDateString()} to {new Date(selectedSprint.endDate).toLocaleDateString()}
            </Typography>
            {selectedSprint.project && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Project: {selectedSprint.project.name} ({selectedSprint.projectKey})
              </Typography>
            )}
            {selectedSprint.goal && (
              <Typography variant="body2" sx={{ mb: 3, fontStyle: 'italic' }}>
                Goal: {selectedSprint.goal}
              </Typography>
            )}
            
            {detailsLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : sprintDetails ? (
              <>
                {/* Completion Rate */}
                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="body2">Sprint Completion</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {stats.completionRate.toFixed(1)}%
                    </Typography>
                  </Box>
                  <LinearProgress 
                    variant="determinate" 
                    value={stats.completionRate} 
                    sx={{ height: 8, borderRadius: 4 ,
                          backgroundColor: '#e0e0e0',
                              '& .MuiLinearProgress-bar': {
                                backgroundColor: getProgressColor(stats.completionRate),
                              },

                    }}
                  />
                </Box>

                {/* Stats Grid */}
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="h5" color="success.main" sx={{ fontWeight: 600 }}>
                        {stats.totalCompleted}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Completed Issues
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="h5" color="error.main" sx={{ fontWeight: 600 }}>
                        {stats.totalIncomplete}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Incomplete Issues
                      </Typography>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="h5" color="primary.main" sx={{ fontWeight: 600 }}>
                        {stats.completedStoryPoints}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Story Points Done
                      </Typography>
                    </Box>
                  </Grid> */}
                  {/* <Grid item xs={6} sm={3}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="h5" color="text.primary" sx={{ fontWeight: 600 }}>
                        {stats.totalStoryPoints}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Total Story Points
                      </Typography>
                    </Box>
                  </Grid> */}
                </Grid>

                <Divider sx={{ my: 2 }} />

                {/* Issue Type Breakdown */}
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4 }}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" color="error.main">
                      {stats.completedBugs}
                    </Typography>
                    <Typography variant="caption">Bugs Fixed</Typography>
                  </Box>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" color="success.main">
                      {stats.completedStories}
                    </Typography>
                    <Typography variant="caption">Stories Done</Typography>
                  </Box>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" color="primary.main">
                      {stats.completedTasks}
                    </Typography>
                    <Typography variant="caption">Tasks Done</Typography>
                  </Box>
                </Box>
              </>
            ) : null}
          </Paper>

          {/* Issues Grid */}
          {sprintDetails && (
            <Grid container spacing={3}>
              {/* Completed Issues */}
              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 2, minHeight: '600px', borderTop: '3px solid #28a745' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      <CompletedIcon color="success" sx={{ mr: 1, verticalAlign: 'middle' }} />
                      COMPLETED
                    </Typography>
                    <Chip 
                      label={sprintDetails.completedIssues.length} 
                      size="small" 
                      sx={{ bgcolor: '#28a745', color: 'white', fontWeight: 600 }} 
                    />
                  </Box>
                  
                  <Box sx={{ maxHeight: '520px', overflowY: 'auto' }}>
                    {sprintDetails.completedIssues.length > 0 ? (
                      sprintDetails.completedIssues.map(issue => renderIssueCard(issue, true))
                    ) : (
                      <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        py: 4,
                        textAlign: 'center'
                      }}>
                        <TaskIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                        <Typography color="text.secondary">
                          No completed issues
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Grid>

              {/* Incomplete Issues */}
              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 2, minHeight: '600px', borderTop: '3px solid #dc3545' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                      <IncompleteIcon color="error" sx={{ mr: 1, verticalAlign: 'middle' }} />
                      INCOMPLETE
                    </Typography>
                    <Chip 
                      label={sprintDetails.incompleteIssues.length} 
                      size="small" 
                      sx={{ bgcolor: '#dc3545', color: 'white', fontWeight: 600 }} 
                    />
                  </Box>
                  
                  <Box sx={{ maxHeight: '520px', overflowY: 'auto' }}>
                    {sprintDetails.incompleteIssues.length > 0 ? (
                      sprintDetails.incompleteIssues.map(issue => renderIssueCard(issue, false))
                    ) : (
                      <Box sx={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        py: 4,
                        textAlign: 'center'
                      }}>
                        <TaskIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                        <Typography color="text.secondary">
                          No incomplete issues
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          )}
        </>
      )}
      {/* Task Details Panel */}
{showTaskPanel && selectedIssue && (
    <>
    {/* Backdrop/Overlay */}
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1299,
        backdropFilter: "blur(2px)",
      }}
      onClick={handleCloseTaskPanel}
    />
  <TaskDetailsPanel
    issue={selectedIssue}
    onClose={handleCloseTaskPanel}
    onUpdate={handleUpdateIssue}
        issueTypes={[
      { id: 1, name: 'Bug' },
      { id: 2, name: 'Epic' }, 
      { id: 3, name: 'Story' },
      { id: 4, name: 'Task' }
    ]}
    statuses={[
      { id: 1, name: 'To Do' },
      { id: 2, name: 'In Progress' },
      { id: 3, name: 'Done' },
    ]}
    priorities={[
      { id: 1, name: 'Highest' },
      { id: 2, name: 'High' },
      { id: 3, name: 'Medium' },
      { id: 4, name: 'Low' },
      { id: 5, name: 'Lowest' }
    ]}
    getInitials={(name) => name?.split(' ').map(n => n[0]).join('').toUpperCase() || '?'}
  />
  </>
)}

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={() => setNotification({ ...notification, open: false })}
      >
        <Alert 
          severity={notification.type} 
          onClose={() => setNotification({ ...notification, open: false })}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CompletedSprintBoard;